import { IS_LOADING } from "../../constants/actionConstants";
import { logoutService } from "../service/logoutService";
import { storage } from "../store/stoarage";
export const isLoading = (data) => {
  return {
    type: IS_LOADING,
    payload: data,
  };
};

export const logout = (refresh_token) => async (dispatch) => {
  dispatch(isLoading(true));
  await logoutService
    .doLogout(refresh_token)
    .then((response) => {
      const { data, status } = response;
      if (!data) {
        storage.clear();
        dispatch(isLoading(false));
        return false;
      } else {
        storage.clear();
        dispatch(isLoading(false));
        return true;
      }
    })
    .catch((error) => {
      storage.clear();
      dispatch(isLoading(false));
      return false;
    });
};
